module.exports = __webpack_public_path__ + "img/ginger@2x.c2c35258.png";